import React from 'react';

import Image from '../../Commons/Image/Image';
import ALMAGRO from '../../../assets/swiss-medical-center/centro_almagro.jpg';

import styles from './SwissMedicalAlmagro.module.scss';

const SwissMedicalAlmagro = () => {
  return (
    <div className={styles.swiss_medical_almagro}>
      <h3>Almagro</h3>
      <p>
        <strong className={styles.swiss_medical_almagro__redText}>Dirección:</strong> Pringles 1337,
        Capital Federal
      </p>
      <p>
        <strong className={styles.swiss_medical_almagro__redText}>Turnos:</strong> 0810-333-8876
      </p>
      <Image
        src={ALMAGRO}
        alt='Sede almagro'
        title='Almagro'
        classes={styles.swiss_medical_almagro__image}
      />
      <p>
        <strong className={styles.swiss_medical_almagro__redText}>Atención Programada</strong>
      </p>
      <p className={styles.swiss_medical_almagro__redText}>Lunes a viernes | 8 hs. a 20 hs.</p>
      <ul>
        <li>Clínica médica</li>
        <li>Cardiología</li>
        <li>Cirugía general</li>
        <li>Infectología</li>
        <li>Neurología</li>
        <li>Traumatología</li>
      </ul>
      <p>
        <strong className={styles.swiss_medical_almagro__redText}>Servicios de Diagnóstico</strong>
      </p>
      <ul>
        <li>Radiología.</li>
      </ul>
    </div>
  );
};

export default SwissMedicalAlmagro;
